import BulletList from 'components/BulletList/BulletList';
import IconButton, { ALIGN_TYPES } from 'components/IconButton/IconButton';
import Thumbnails from 'components/Thumbnails/Thumbnails';
import Space from 'corecomponents/Space/Space';
import PropTypes from 'prop-types';

import { BASE_PATHS } from '../../routes/paths';

function AccountUnitDetail({
  unitId,
  infoList,
  thumbnailsItems,
  doNotShowListing,
}) {
  return (
    <div>
      <div className="gap-xs flex flex-wrap items-center justify-between">
        <BulletList flexWrap listItems={infoList} />
        {!doNotShowListing && (
          <IconButton
            align={ALIGN_TYPES.LEFT}
            label="VIEW LISTING"
            className="ml-auto"
            to={`${BASE_PATHS.HOME}/${unitId}`}
          />
        )}
      </div>
      {!!thumbnailsItems?.length && (
        // Empty className To find easier in the future.
        <div className="accountUnitDetail">
          <Space />
          <Thumbnails
            unitId={doNotShowListing ? '' : unitId}
            items={thumbnailsItems}
          />
          <Space />
        </div>
      )}
    </div>
  );
}

AccountUnitDetail.propTypes = {
  unitId: PropTypes.string.isRequired,
  infoList: PropTypes.arrayOf(PropTypes.node).isRequired,
  thumbnailsItems: PropTypes.arrayOf(PropTypes.object),
  doNotShowListing: PropTypes.bool,
};

AccountUnitDetail.defaultProps = {
  doNotShowListing: false,
  thumbnailsItems: [],
};

export default AccountUnitDetail;
